




































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class AsyncPython extends Vue {
}
